/**
 * The roles a project starts with.
 *
 * Roles are now per project and live in the database — see
 * `common/useProjectRoles` for the hook every screen reads, and
 * `server/src/controllers/projectRoleController.js` for the CRUD behind it.
 * This list is what the server seeds a project with, and what the UI shows
 * while that first request is still in flight, so a dropdown is never empty.
 * Keep it in step with `defaultProjectRoles` on the server.
 *
 * It is deliberately NOT the `/accessroles` endpoint: that reads the `roles`
 * collection, which on the shared cluster is owned by a different product and
 * returns "Learner", "Admin", "Skill Master" and "Content Reviewer".
 */
export const PROJECT_ROLES = [
  "Project Manager",
  "Scrum Master",
  "Business Analyst",
  "Project Lead",
  "Developer",
  "QA Engineer",
  "UX/UI Designer",
  "DevOps Engineer",
  "Administration",
];

/** Shape expected by SelectMenuTextField, for the fallback list. */
export const PROJECT_ROLE_OPTIONS = PROJECT_ROLES.map((role) => ({
  name: role,
  value: role,
}));

export default PROJECT_ROLES;

/** Turns whatever the server returned into the message worth showing a person. */
export const roleErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;
